export {default as ImageHero} from './compositions/ImageHero';
export {default as WidgetHero} from './compositions/WidgetHero';
